export default "/images/vendor/flag-icon-css/flags/4x3/hu.svg?e404d718cffb5bd06467cbb60786edab";